/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { agentsDeletePolicyGrant } from "../funcs/agentsDeletePolicyGrant.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  DeleteAgentPolicyGrantRequest,
  DeleteAgentPolicyGrantSecurity,
} from "../models/operations/deleteagentpolicygrant.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type AgentsDeletePolicyGrantMutationVariables = {
  request: DeleteAgentPolicyGrantRequest;
  security?: DeleteAgentPolicyGrantSecurity | undefined;
  options?: RequestOptions;
};

export type AgentsDeletePolicyGrantMutationData = void;

export type AgentsDeletePolicyGrantMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * deletePolicyGrant agents
 */
export function useAgentsDeletePolicyGrantMutation(
  options?: MutationHookOptions<
    AgentsDeletePolicyGrantMutationData,
    AgentsDeletePolicyGrantMutationError,
    AgentsDeletePolicyGrantMutationVariables
  >,
): UseMutationResult<
  AgentsDeletePolicyGrantMutationData,
  AgentsDeletePolicyGrantMutationError,
  AgentsDeletePolicyGrantMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildAgentsDeletePolicyGrantMutation(client, options),
    ...options,
  });
}

export function mutationKeyAgentsDeletePolicyGrant(): MutationKey {
  return ["@gram/client", "agents", "deletePolicyGrant"];
}

export function buildAgentsDeletePolicyGrantMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: AgentsDeletePolicyGrantMutationVariables,
  ) => Promise<AgentsDeletePolicyGrantMutationData>;
} {
  return {
    mutationKey: mutationKeyAgentsDeletePolicyGrant(),
    mutationFn: function agentsDeletePolicyGrantMutationFn({
      request,
      security,
      options,
    }): Promise<AgentsDeletePolicyGrantMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(agentsDeletePolicyGrant(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
